import { LOGO_MAX_BYTES, LOGO_MIMES, type EmpresaPerfilDto, type EmpresaPerfilResponse, type MeDto } from '@triade/contracts';

/** Perfil em branco (empresa sem perfil gravado). Texto vazio = campo limpo na API. */
export const FORM_VAZIO: EmpresaPerfilDto = {
  razaoSocial: '', nomeFantasia: '', cnpj: '', endereco: '', cidade: '', uf: '', cep: '', telefone: '', email: '', site: '',
  inscricaoEstadual: '', inscricaoMunicipal: '', regimeTributario: '', contatoNome: '', rodapePdf: '', sobre: '',
};

/** CNPJ (14 digitos) como 00.000.000/0000-00 e CEP como 00000-000: so apresentacao; a API guarda digitos. */
export function mascaraCnpj(v: string): string {
  return v.length === 14 ? v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : v;
}
export function mascaraCep(v: string): string {
  return v.length === 8 ? `${v.slice(0, 5)}-${v.slice(5)}` : v;
}

export function deResposta(p: EmpresaPerfilResponse): EmpresaPerfilDto {
  return {
    razaoSocial: p.razaoSocial ?? '',
    nomeFantasia: p.nomeFantasia ?? '',
    cnpj: mascaraCnpj(p.cnpj ?? ''),
    endereco: p.endereco ?? '',
    cidade: p.cidade ?? '',
    uf: p.uf ?? '',
    cep: mascaraCep(p.cep ?? ''),
    telefone: p.telefone ?? '',
    email: p.email ?? '',
    site: p.site ?? '',
    inscricaoEstadual: p.inscricaoEstadual ?? '',
    inscricaoMunicipal: p.inscricaoMunicipal ?? '',
    regimeTributario: p.regimeTributario ?? '',
    contatoNome: p.contatoNome ?? '',
    rodapePdf: p.rodapePdf ?? '',
    sobre: p.sobre ?? '',
  };
}

/** Quem altera o perfil e a logo: permissao empresa.editar (a API repete a regra e responde 403 para os demais). */
export function podeEditarPerfil(permissoes: MeDto['permissoes'] | undefined): boolean {
  return permissoes?.includes('empresa.editar') ?? false;
}

/** Conferencia previa (so para poupar a ida ao servidor): tamanho e tipo declarado. Quem decide e a API, pelos magic bytes. */
export function problemaNaLogo(arquivo: { size: number; type: string }): string | null {
  if (arquivo.size === 0) return 'O arquivo está vazio';
  if (arquivo.size > LOGO_MAX_BYTES) return `A logo passa de ${LOGO_MAX_BYTES / 1024} KB`;
  if (!(LOGO_MIMES as readonly string[]).includes(arquivo.type)) return 'Use uma imagem PNG ou JPEG (SVG não é aceito)';
  return null;
}
